<!--优惠券-->
<template>
  <div class="coupon-container" :style="'min-height:'+min_height+'px;'">
    <div class="coupon-content">
      <el-row :gutter="16" v-if="couponList.length>0">
        <template v-for="(coupon,index) of couponList">
          <el-col :span="6" v-for="list of coupon.couponVOList">
            <div class="coupon-list">
              <div class="coupon-discount">
                <p>
                  <span class="money-icon">￥</span>
                  <span class="discount">{{list.preferentialAmount}}</span>
                </p>
              </div>
              <div class="max-price">满{{list.usingDoor}}可用</div>
              <div class="validity">{{list.startTime}}-{{list.endTime}}</div>
              <div class="coupon-name" style="padding-top: 30px;">使用：
                <span v-if="coupon.name">{{coupon.name}}</span>
                <span v-else>-</span>
              </div>
              <div class="coupon-name">券名：
                <!--优惠券类型（1：新人专享优惠券, 2：商品优惠券, 3：店铺优惠券)-->
                <span v-if="list.type==1">新人专享优惠券</span>
                <span v-else-if="list.type==2">商品优惠券</span>
                <span v-else-if="list.type==3">店铺优惠券</span>
              </div>
              <div class="coupon-button">
                <el-button type="danger" round @click="playNow(coupon)">立即使用</el-button>
              </div>
            </div>
          </el-col>
        </template>
      </el-row>
      <el-empty description="暂无可用优惠券" v-else/>
      <!-- 分页 -->
      <page :total="tablePage.total" class="pagination" :page="tablePage.currentPage" @currentPage="currentPage" :limit="tablePage.pageSize" style="padding: 0px 25px 15px 10px;"/>
    </div>
  </div>
</template>

<script>
import {couponsAvailableList} from '@/api/interfaceApi'
import page from "@/components/page/pages";
export default {
  name: "coupon",
  components:{page},
  data(){
    return{
      min_height: document.documentElement.clientHeight - 396,
      couponList: [],
      /*分页*/
      tablePage: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      cid:0,
    }
  },
  methods:{
    /*使用优惠券*/
    playNow(id){

    },
    //切换分页
    currentPage(page) {
      this.tablePage.currentPage = page;
    },
    /*获取优惠券列表*/
    getCouponsAvailableList(){
      couponsAvailableList({pageNum: this.tablePage.currentPage, type: 1, userId: this.cid, request: 'form', uid: this.cid,}).then(res=>{
        if (res.code==200){
          this.tablePage.total=res.content.totalNum;
          this.couponList=res.content.list;
        }
      })
    }
  },
  mounted() {
    this.getCouponsAvailableList();
  },
  beforeMount() {
    this.cid=JSON.parse(sessionStorage.getItem('loginData')).cid;
  }
}
</script>
<style scoped>
.coupon-container >>> .coupon-content .coupon-list .coupon-button .el-button.is-round {
  border-radius: 20px;
  padding: 12px 23px;
  border: 1px solid #FE273B;
  background: #F1F1F1;
  color: #FE273B;
  width: 105px;
  font-size: 14px;
}
</style>
<style scoped lang="scss">
.coupon-container{
  padding: 20px;
  background: #ffffff;
  .coupon-content{
    .coupon-list{
      height: 250px;
      width: 100%;
      background: url("~@/assets/img/cloud/couponBackground.png");
      background-size: 100% 100%;
      margin-bottom: 20px;
      padding-top: 20px;
      .coupon-discount{
        display: flex;
        justify-content: center;
        p{
          margin-block-start: 0px;
          margin-block-end: 0px;
          .money-icon{
            font-size: 16px;
            color: #ffffff;
          }
          .discount{
            font-size: 30px;
            color: #ffffff;
          }
        }
      }
      .max-price{
        display: flex;
        justify-content: center;
        font-size: 16px;
        color: #ffffff;
        padding-bottom: 5px;
      }
      .validity{
        display: flex;
        justify-content: center;
        font-size: 12px;
        color: #FFBFC5;
      }
      .coupon-name{
        font-size: 14px;
        color: #333333;
        padding-left: 20px;
        width: 85%;
        white-space: nowrap;
        text-overflow: ellipsis;
        word-break: break-word;
        overflow: hidden;
        span{
          color: #666666;
        }
      }
      .coupon-button{
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 40px;
      }
    }
  }
}
</style>